import React, { FC, useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import Markdown from 'markdown-to-jsx';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { DFSExpression } from '../services/expressions';
import { FormContext } from '../FormContext';
import { Theme } from '@material-ui/core/styles';

export declare type RawLabelParams = {
  [key: string]: DFSExpression;
};
export declare type LabelParams = {
  [key: string]: string;
} | undefined | null;

export interface TemplatedTextProps {
  className?: string;
  template: string;
  params?: RawLabelParams;
}

var useStyles = makeStyles(function(_: Theme) {
  return {
    root: {
      '& h1, h2, h3, h4, h5, h6': {
        marginBlockEnd: 'auto'
      }
    }
  }
});

export const TemplatedText: FC<TemplatedTextProps> = function(r) {

    const { template, params } = r;
    let [ parsedParams, setParsedParams ] = useState({});
    const { scope, expMgr } = useContext(FormContext);
    const [ text, setText ] = useState('');

    useEffect(() => {
      const t = interpolateTemplate(template, parsedParams);

      setText(t);
    }, [template, parsedParams]);

    useEffect(function r() {
      if (!params) {
        return;
      }

      const subscription = combineLatest(
        Object
          .entries(params)
          .map(function(r) {
            const [ key, expr ] = r;

            return expMgr!.watch(expr, scope)
              .pipe(
                map(function(val) {
                  return { [key]: val };
                  // var e;
                  // return e = {}, e[key] = r, e
                })
              )
          })
        )
        .pipe(map(function(params) {
          return params.reduce(function(acc, curr) {
            // return __assign(__assign({}, r), e)
            return Object.assign({}, Object.assign({}, acc), curr);
          }, {})
        })).subscribe(function(params) {
          setParsedParams(params);
        });
        return function() {
          return subscription.unsubscribe()
        }
      }, [params, expMgr, scope]);

    const classes = useStyles({});

    return (
      <div  className = { classes.root.concat(r.className ? ' '.concat(r.className) : '') }>
        <Markdown>
          { text }
        </Markdown>
      </div>
    )
};

// this is causing a slowdown
function interpolateTemplate(template: string, params: { [key: string]: any }) {
    let processed = template;
    if (!processed) {
      return processed;
    }
    const variables = processed.match(/\{\{[\w_-\d]+\}\}/g);

    if (variables === null) {
      return processed;
    }

    for (const param of Object.values(variables)) {
      let replacement = undefined;

      if (params === undefined || params === null) {
        replacement = '';
      } else {
        replacement = params[param.slice(2, param.length - 2)];

        if (replacement === undefined || replacement === null) {
          replacement = '';
        }
      }

      const replacementValue = '' + replacement;
      processed = processed?.replace(param, replacementValue)
    }

    return processed;
}
